import { Component, inject } from "@angular/core";
import { UiKitModule } from "@app/ui-kit.module";
import { ToggleItemTextVisibilityButtonComponent } from "@components/toggle-item-text-visibility-button/toggle-item-text-visibility-button.component";
import { ToggleLockButtonComponent } from "@components/toggle-lock-button/toggle-lock-button.component";
import { ToggleVisibilityButtonComponent } from "@components/toggle-visibility-button/toggle-visibility-button.component";
import { FloorplanState } from "@domain/project/floorplan/floorplan-state";
import { FloorplanZonesService } from "@project/floorplan-zones.service";
import { FloorplanMenuItemButtonsComponent } from "@project/floorplanner/floorplan-menu/fgds/floorplan-menu-item-buttons/floorplan-menu-item-buttons.component";
import { FloorplanService } from "@project/floorplanner/floorplan.service";
import { DraggedItemType, FloorplanDragDropService } from "@utils/floorplan-drag-drop.service";

@Component({
  selector: "app-isolation-room-menu",
  imports: [
    UiKitModule,
    FloorplanMenuItemButtonsComponent,
    ToggleLockButtonComponent,
    ToggleVisibilityButtonComponent,
    ToggleItemTextVisibilityButtonComponent,
  ],
  templateUrl: "./isolation-room-menu.component.html",
  styleUrl: "./isolation-room-menu.component.scss",
})
export class IsolationRoomMenuComponent {
  private floorplanService = inject(FloorplanService);
  private floorplanZonesService = inject(FloorplanZonesService);
  private dragDropService = inject(FloorplanDragDropService);

  protected floorplanState: FloorplanState;
  protected readonly tooltipText: string = $localize`:@@floorplan.monitoring.button.addIsolationRoom:Add isolation room`;

  constructor() {
    this.floorplanState = this.floorplanService.selectedFloorplan.floorplanState;
  }

  protected addIsolationRoom() {
    this.floorplanZonesService.addIsolationRoom();
  }

  protected dragIsolationRoom() {
    this.dragDropService.setDragged({ type: DraggedItemType.ISOLATION_ROOM });
  }

  protected updateIsolationRoomsItemTextVisibility(visible: boolean) {
    this.floorplanState.updateIsolationRoomsItemTextVisibility(visible);
  }
}
